module.exports = __webpack_public_path__ + "static/media/gardenEmpty.74a301f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenEmpty.jpg
// module id = 168
// module chunks = 0